/* Glow Therapy · theme.js · rails, drawers, cart, saved picks, night shift, sticky header, reveals */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const G = window.GT || {};
  const body = document.body;

  /* toast */
  const toastEl = $('[data-toast]');
  let toastT;
  const toast = (msg) => {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('is-show'), 2600);
  };
  window.GT.toast = toast;

  /* overlay + drawers (cart, menu, search) */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  let lastFocus = null;
  const focusables = (el) => $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', el).filter((n) => n.offsetParent !== null);
  const open = (el) => {
    if (!el) return;
    if (openDrawer && openDrawer !== el) close();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-open')); }
    body.classList.add('gt-locked');
    openDrawer = el;
    const f = focusables(el)[0];
    setTimeout(() => (f || el).focus({ preventScroll: true }), 60);
  };
  const close = () => {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    if (overlay) { overlay.classList.remove('is-open'); setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 300); }
    body.classList.remove('gt-locked');
    const el = openDrawer;
    openDrawer = null;
    el.dispatchEvent(new CustomEvent('gt:closed'));
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };
  window.GT.openDrawer = open;
  window.GT.closeDrawer = close;
  overlay && overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (!openDrawer) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = focusables(openDrawer);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-drawer-open]');
    if (t) { e.preventDefault(); open(document.getElementById(t.getAttribute('data-drawer-open'))); }
    if (e.target.closest('[data-drawer-close]')) close();
  });

  /* cart */
  const cartTab = (which) => {
    $$('[data-cart-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.cartTab === which)));
    $$('[data-cart-panel]').forEach((p) => { p.hidden = p.dataset.cartPanel !== which; });
    const foot = $('[data-cart-foot]');
    if (foot) foot.hidden = which !== 'bag';
  };
  const openCart = (which = 'bag') => { cartTab(which); renderSaved(); open($('[data-cart-drawer]')); };
  window.GT.openCart = openCart;
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-cart-open]');
    if (o) { e.preventDefault(); openCart(o.dataset.cartOpen || 'bag'); return; }
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    const tab = e.target.closest('[data-cart-tab]');
    if (tab) cartTab(tab.dataset.cartTab);
  });

  const setCount = (n) => $$('[data-cart-count]').forEach((c) => { c.dataset.count = n; c.textContent = n > 0 ? n : ''; });

  const refreshCart = async (openAfter) => {
    try {
      const res = await fetch(`${G.routes.root}?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('[data-cart-drawer]');
      const cur = $('[data-cart-drawer]');
      if (fresh && cur) {
        const wasOpen = cur.classList.contains('is-open');
        cur.innerHTML = fresh.innerHTML;
        if (wasOpen) cur.classList.add('is-open');
      }
      const c = await (await fetch('/cart.js')).json();
      setCount(c.item_count);
      renderSaved();
      if (openAfter) openCart('bag');
    } catch (err) { console.warn(err); }
  };
  window.GT.refreshCart = refreshCart;

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${G.routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || G.strings.error);
      toast(G.strings.added || 'Added to your bag');
      await refreshCart(true);
    } catch (err) { toast(err.message || G.strings.error); }
    finally { btn && btn.removeAttribute('aria-busy'); }
  });

  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-qty]');
    if (!q) return;
    q.disabled = true;
    await fetch(`${G.routes.cart_change_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: q.dataset.qty, quantity: Number(q.dataset.qtyTo) }) });
    refreshCart(false);
  });

  let noteT;
  document.addEventListener('input', (e) => {
    const n = e.target.closest('[data-cart-note]');
    if (!n) return;
    clearTimeout(noteT);
    noteT = setTimeout(() => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) }), 500);
  });

  /* saved picks (affiliate wishlist, per browser) */
  const KEY = 'gt_saved_v1';
  const getSaved = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const setSaved = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} };
  const syncSaveButtons = () => {
    const handles = getSaved().map((s) => s.handle);
    $$('[data-save]').forEach((b) => {
      let d; try { d = JSON.parse(b.dataset.save); } catch (e) { return; }
      const on = handles.includes(d.handle);
      b.setAttribute('aria-pressed', String(on));
      const l = b.querySelector('[data-save-label]');
      if (l) l.textContent = on ? 'Saved to my picks' : 'Save to my picks';
    });
    $$('[data-saved-count]').forEach((c) => { c.textContent = `(${handles.length})`; });
  };
  const renderSaved = () => { $$('[data-saved-list]').forEach(renderSavedInto); syncSaveButtons(); };
  const renderSavedInto = (ul) => {
    const list = getSaved();
    ul.textContent = '';
    if (!list.length) {
      const li = document.createElement('li');
      li.className = 'gt-muted';
      li.textContent = 'Nothing saved yet. Tap the heart on anything that ships from another brand.';
      ul.appendChild(li);
    }
    list.forEach((s) => {
      const li = document.createElement('li');
      const img = document.createElement('img'); img.src = s.img || ''; img.alt = ''; img.loading = 'lazy';
      const mid = document.createElement('div');
      const a = document.createElement('a'); a.href = s.url; a.className = 'gt-line__title'; a.textContent = s.title;
      const p = document.createElement('div'); p.className = 'gt-mono'; p.textContent = `${s.price} at ${s.retailer}`;
      mid.append(a, p);
      const right = document.createElement('div'); right.style.display = 'flex'; right.style.flexDirection = 'column'; right.style.alignItems = 'flex-end';
      const go = document.createElement('a'); go.href = s.out; go.target = '_blank'; go.rel = 'sponsored nofollow noopener'; go.className = 'gt-btn gt-btn--sm'; go.textContent = 'Shop ↗'; go.dataset.outbound = ''; go.dataset.retailer = s.retailer; go.dataset.handle = s.handle;
      const rm = document.createElement('button'); rm.type = 'button'; rm.className = 'gt-saved__remove'; rm.textContent = 'Remove'; rm.addEventListener('click', () => { setSaved(getSaved().filter((x) => x.handle !== s.handle)); renderSaved(); syncSaveButtons(); });
      right.append(go, rm);
      li.append(img, mid, right);
      ul.appendChild(li);
    });
    syncSaveButtons();
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-save]');
    if (!b) return;
    e.preventDefault();
    let d; try { d = JSON.parse(b.dataset.save); } catch (err) { return; }
    const list = getSaved();
    const i = list.findIndex((x) => x.handle === d.handle);
    if (i > -1) { list.splice(i, 1); toast(G.strings.unsaved || 'Removed from your picks'); }
    else { list.unshift(d); toast(G.strings.saved || 'Saved to your picks'); b.animate && b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 320 }); }
    setSaved(list.slice(0, 60));
    syncSaveButtons();
  });

  /* outbound affiliate click tracking (Shopify customer events / GA pick this up) */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-outbound]');
    if (!a) return;
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('affiliate_click', { retailer: a.dataset.retailer, handle: a.dataset.handle, url: a.href });
      window.dataLayer && window.dataLayer.push({ event: 'affiliate_click', retailer: a.dataset.retailer, product: a.dataset.handle });
    } catch (err) {}
  });

  /* rails: arrows, progress, keyboard */
  const initRail = (rail) => {
    const track = $('[data-rail-track]', rail);
    if (!track) return;
    const prev = $('[data-rail-prev]', rail.closest('[data-rail-scope]') || rail);
    const next = $('[data-rail-next]', rail.closest('[data-rail-scope]') || rail);
    const bar = $('[data-rail-progress]', rail.closest('[data-rail-scope]') || rail);
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth * 0.8; };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (bar) bar.style.setProperty('--p', `${Math.max(12, Math.min(100, ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100))}%`);
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    track.setAttribute('tabindex', track.getAttribute('tabindex') || '0');
    window.addEventListener('resize', update);
    update();
  };
  $$('[data-rail]').forEach(initRail);
  window.GT.initRail = initRail;
  document.addEventListener('shopify:section:load', (e) => $$('[data-rail]', e.target).forEach(initRail));

  /* header: hide on scroll down, show on scroll up; mobile bar does the same */
  let lastY = window.scrollY;
  const header = $('[data-sticky-header]');
  const onScroll = () => {
    const y = window.scrollY;
    const down = y > lastY && y > 160;
    body.classList.toggle('gt-header-hide', down && !openDrawer && !(header && header.matches(':focus-within')));
    body.classList.toggle('gt-mbar-hide', down && y > 600);
    body.classList.toggle('gt-scrolled', y > 8);
    lastY = y;
  };
  window.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });

  /* reveal on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach((el) => io.observe(el));
  } else { $$('[data-reveal]').forEach((el) => el.classList.add('is-in')); }

  /* night shift: after nightStart (default 9pm) the site goes midnight. User can toggle; remembered per browser. */
  const NKEY = 'gt_night';
  const applyNight = (on) => {
    body.classList.toggle('is-night', on);
    $$('[data-night-toggle]').forEach((b) => { b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-label', on ? 'Switch to day mode' : 'Switch to Night Shift mode'); });
  };
  let pref = null; try { pref = localStorage.getItem(NKEY); } catch (e) {}
  const h = new Date().getHours();
  applyNight(pref ? pref === 'on' : !!(G.nightShift && (h >= (G.nightStart || 21) || h < 5)));
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-night-toggle]');
    if (!b) return;
    const on = !body.classList.contains('is-night');
    applyNight(on);
    try { localStorage.setItem(NKEY, on ? 'on' : 'off'); } catch (err) {}
    toast(on ? 'Night Shift on. Lights low, phone down soon.' : 'Good morning.');
  });

  /* sticky buy bar on product pages */
  const stickyBar = $('[data-sticky-buy]');
  const mainBuy = $('[data-main-buy]');
  if (stickyBar && mainBuy) {
    /* scroll-based (not IntersectionObserver) so anchor jumps and restored scroll positions are caught too */
    const syncSticky = () => stickyBar.classList.toggle('is-on', mainBuy.getBoundingClientRect().bottom < 0);
    window.addEventListener('scroll', () => requestAnimationFrame(syncSticky), { passive: true });
    window.addEventListener('resize', syncSticky);
    syncSticky();
  }

  /* predictive search (drawer with [data-search-drawer], input [data-search-input], results [data-search-results]) */
  const sd = $('[data-search-drawer]');
  document.addEventListener('click', (e) => { if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(sd); } });
  const si = $('[data-search-input]');
  const sr = $('[data-search-results]');
  let st;
  si && sr && si.addEventListener('input', () => {
    clearTimeout(st);
    const q = si.value.trim();
    if (q.length < 2) { sr.innerHTML = ''; sr.hidden = true; return; }
    st = setTimeout(async () => {
      try {
        const r = await fetch(`${G.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,query&resources[limit]=6&section_id=predictive-search`);
        const t = await r.text();
        const d = new DOMParser().parseFromString(t, 'text/html');
        const inner = d.querySelector('[data-predictive]');
        sr.innerHTML = inner ? inner.outerHTML : '';
        sr.hidden = false;
      } catch (err) {}
    }, 220);
  });

  window.GT.syncSaved = syncSaveButtons;
  window.GT.renderSaved = renderSaved;
  syncSaveButtons();
  if ($('[data-saved-page]')) renderSaved();
  document.addEventListener('shopify:section:load', syncSaveButtons);
})();
